import { render, staticRenderFns } from "./Siembra.vue?vue&type=template&id=007482ba&scoped=true"
import script from "./Siembra.vue?vue&type=script&lang=js"
export * from "./Siembra.vue?vue&type=script&lang=js"
import style0 from "./Siembra.vue?vue&type=style&index=0&id=007482ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007482ba",
  null
  
)

export default component.exports